import { render, staticRenderFns } from "./ProspectsDetails.vue?vue&type=template&id=5420792c&scoped=true&"
import script from "./ProspectsDetails.vue?vue&type=script&lang=ts&"
export * from "./ProspectsDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ProspectsDetails.vue?vue&type=style&index=0&id=5420792c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5420792c",
  null
  
)

export default component.exports